import { render, staticRenderFns } from "./SettingsOrg.vue?vue&type=template&id=7b87b366&"
import script from "./SettingsOrg.vue?vue&type=script&lang=js&"
export * from "./SettingsOrg.vue?vue&type=script&lang=js&"
import style0 from "./SettingsOrg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsOrg.vue"
export default component.exports